// React must be in scope (classic JSX runtime).
import React from 'react';
import styled, { keyframes } from 'styled-components';

import colors from '@/styles/colors';

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.35; }
  40% { transform: translateY(-4px); opacity: 1; }
`;

const Row = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 0;
`;

const Dot = styled.span<{ $delay: number }>`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${colors.textSecondary};
  animation: ${bounce} 1.2s infinite ease-in-out;
  animation-delay: ${({ $delay }) => `${$delay}ms`};
`;

/** Three staggered bouncing dots — the "assistant is thinking" indicator. */
const TypingDots: React.FC = () => (
  <Row aria-label="Assistant is thinking" data-testid="typing-dots">
    <Dot $delay={0} />
    <Dot $delay={160} />
    <Dot $delay={320} />
  </Row>
);

export default TypingDots;
